import type { RichTextField } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';

type Props = {
  field: RichTextField;
  /** Owned by the calling card, so each layout sets its own type scale. */
  className: string;
};

export function StepTitle({ field, className }: Props) {
  return (
    <PrismicRichText
      field={field}
      components={{
        heading3: ({ children }) => <h3 className={className}>{children}</h3>,
      }}
    />
  );
}
